export const API_URL = "https://www.blendle2020.kleinprodesign.nl/back/main-api.php";
export default API_URL;